import _has from 'lodash/has';
import { MessageBox } from 'webmd-elements';
import regservice from 'webmd-reg-service/index.es6';

// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';

export default {
	computed: {
		isSiteFronts() {
			const sfData = this.store.cms.siteFronts;
			if (_has(sfData, 'mode')) {
				return sfData.mode.toLowerCase() === 'sitefronts';
			}
			return false;
		},

	},
	mounted() {
		/*
		 *Hard coded the cap ID in the below statement since the living healthy TOC is
		 *using sitefront newsletter but is not actually a sitefront cap.
		 *Reference ticket : PPE-416103
		 */
		if (this.isSiteFronts || this.$capId === '091e9c5e81f6eb7c') {
			const $nlModule = document.querySelector('.sf-nls-content');
			if ($nlModule && !$nlModule.classList.contains('hasSubmitListner')) {
				/*
				 *
				 *  Added addSubmitListner class to restrict attaching multiple eventlisteners
				 *  to stop multiple api calls
				 *  Since newsletter component is loaded twice for some caps
				 *  once from : webmd-site-front-header
				 *  once from : webmd-newsletter
				 *  Example : 091e9c5e813efa75 (which includes normal and sitefront pages)
				 *
				 */
				$nlModule.classList.add('hasSubmitListner');

				const checkboxCount = $nlModule.querySelectorAll('input[type=checkbox]').length;
				$nlModule.querySelector('.sf-nls-form').addEventListener('submit', ($event) => {
					$event.preventDefault();

					const ids = [];
					const email = $nlModule.querySelector('input[type=email]').value;

					$nlModule.querySelectorAll('input:checked').forEach((cb) => {
						ids.push(cb.value);
					});

					if (ids.length) {
						regservice.subscribetoNL(email, (checkboxCount > 1) ? ids.join(',')
							: ids[0]).then((response) => {
							const form = $nlModule.querySelector('form');
							form.classList.add('success');
							form.innerHTML = `<p>Thanks for subscribing!</p>${email}`;
							const mmodule = checkboxCount > 1 ? 'nl-multi' : 'nl-single';
							const mlink = this.getMlinkValueSF(response, checkboxCount, ids);
							if (response.code === 3) {
								window.wmdPageLink('reg-success_l-nl');
							}
							window.wmdPageLink(`${mmodule}_${mlink}`);
						}).catch(() => {
							this.isError = true;
						});
					} else {
						MessageBox.confirm(
							'Please select a newsletter to subscribe.',
							'',
							{
								confirmButtonText: 'OK',
								size: 'large',
							},
						);
					}
				});
			}
		}
	},

	created() {
		this.store = useStore(this.$pinia);
		if (this.isSiteFronts) {
			/* eslint-disable no-unused-expressions */
			import(/* webpackChunkName: "load-dynamic" */ '../stylesheets/sitefront.scss');
		}
	},

	methods: {
		getMlinkValueSF(response, checkboxCount, nlIds) {
			let nlIndex;
			let omniLink;
			const newsletterId = nlIds[0] ? nlIds[0] : '';
			if (checkboxCount > 1) {
				const nlArray = [];
				nlIds.forEach((id) => {
					nlArray.push(id);
				});

				nlIndex = nlArray.join('-');

				if (response.code === 3) {
					omniLink = `n:${nlIndex}`;
				} else if (response.code === 1) {
					omniLink = `r:${nlIndex}`;
				} else {
					omniLink = `e3-${nlIndex}`;
				}
			} else if (response.code === 3) {
				omniLink = `n:${newsletterId}`;
			} else if (response.code === 1) {
				omniLink = `r:${newsletterId}`;
			} else {
				omniLink = 'e3';
			}
			return omniLink;
		},
	},

};
